<template>
  <div class="text-right">
    <small class="text-muted">Desenvolvido por:</small> &nbsp;&nbsp;
    <b-link href="https://securamdata.com" target="_brank">securamdata.com</b-link>
  </div>
</template>
<script>
import {
  BLink,
  VBTooltip,
} from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BLink,
    VBTooltip,
  },
}

</script>
